import React from 'react';
import InventoryCell from "../InventoryCell";
import BookCell from '../BookCell';
import AvailabilityCell from "../AvailabilityCell";
import {TableRow} from 'material-ui/Table';


const AvailabilityRowMobile = ({property, inventoryType, showRate, customer, displayNoOfNights}) => {
  const availabilityCells = [];

  for(let i = 0; i < displayNoOfNights; i++) {
    let item = inventoryType.rateByDay[i];
      availabilityCells.push(
          <AvailabilityCell key={i} rateByDay={item} customer={customer} showRate={showRate} />
      )
  }
  return (
      <TableRow>
        <InventoryCell key={inventoryType.id}
                       name={inventoryType.name}
                       rateType={inventoryType.rateByDay[0].type}
                       showRate={showRate}/>
        {availabilityCells}
        <BookCell key={inventoryType.id+'book'}
                  rateType={inventoryType.rateByDay[0].type}
                  showRate={showRate}
                  bookable={customer.bookable}
                  inventoryType={inventoryType} />
      </TableRow>
  )
};

export default AvailabilityRowMobile;



// WEBPACK FOOTER //
// ./src/components/mobile/AvailabilityRowMobile.js